import { useEffect, useRef, useState } from 'react';
import { subscribeMeter, getLatestSnapshot } from './meterSocket';
import { matchMeterField } from './meterFields';

const DEFAULT_METER_ID = 'TEST_1_1';
const MAX_POINTS = 500;

function applySnapshot(snapshot, field, pointsRef) {
    if (!field || !snapshot || snapshot.error) return null;
    const raw = field.get(snapshot);
    const value = Number(raw);
    if (raw === undefined || raw === null || Number.isNaN(value)) return null;
    pointsRef.current = [...pointsRef.current, { time: new Date().toISOString(), value }].slice(-MAX_POINTS);
    return { loading: false, error: null, points: pointsRef.current, latest: value };
}


export default function useMeterField(title, { meterId = DEFAULT_METER_ID, skip = false } = {}) {
    const field = skip ? null : matchMeterField(title);
    const fieldRef = useRef(field);
    fieldRef.current = field;

    const [state, setState] = useState({ loading: false, error: null, points: [], latest: null });
    const pointsRef = useRef([]);

    useEffect(() => {
        pointsRef.current = [];
        if (!field || skip) {
            setState({ loading: false, error: null, points: [], latest: null });
            return;
        }
        const cached = getLatestSnapshot(meterId);
        const applied = cached && applySnapshot(cached, field, pointsRef);
        setState(applied || { loading: true, error: null, points: [], latest: null });
    }, [field?.label, skip, meterId]);

    useEffect(() => {
        if (skip) return undefined;

        const handleSnapshot = (snapshot) => {
            if (!fieldRef.current) return;
            if (snapshot?.error) {
                setState((prev) => ({ ...prev, loading: false, error: snapshot.error }));
                return;
            }
            const applied = applySnapshot(snapshot, fieldRef.current, pointsRef);
            if (applied) setState(applied);
            else setState((prev) => ({ ...prev, loading: false }));
        };

        return subscribeMeter(meterId, handleSnapshot);
    }, [meterId, skip]);

    return { field, ...state };
}
